import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { createTrackingUtils } from "../index";
import { UIPersonalisationParameters } from "@flights/types";

export const utils = createTrackingUtils({
  name: "flights_web_aa_flexibility_prediction",
  defaultStage: 1,
  stages: {
    main: 1,
    is_flexible: 2,
    is_not_flexible: 3,
    no_flexibility_data: 4
  },
  goals: {
    click_on_flexi_banner: 1
  },
  goalsWithValue: ["click_on_offer_count"]
});

export const useTrackFlexibilityPrediction = (personalisationAttributes: UIPersonalisationParameters | undefined) => {
  utils.stages.main();

  if (personalisationAttributes && typeof personalisationAttributes.isUserFlexible === "boolean") {
    if (personalisationAttributes.isUserFlexible) {
      utils.stages.is_flexible();
    } else {
      utils.stages.is_not_flexible();
    }
  } else {
    utils.stages.no_flexibility_data();
  }
};

export const FLEXIBILITY_PREDICTION_EXPERIMENT_COUNTER_KEY = "flexibility_prediction_counter";

export const trackPredictionExperimentCounter = (offerToken: string) => {
  const currentValue = flightsSessionStore.get(FLEXIBILITY_PREDICTION_EXPERIMENT_COUNTER_KEY) ?? {};
  const updatedValue = { ...currentValue, [offerToken]: 1 };

  flightsSessionStore.set(FLEXIBILITY_PREDICTION_EXPERIMENT_COUNTER_KEY, updatedValue);

  const clickedCounter = Object.keys(updatedValue).length;

  clickedCounter > 0 && utils.goalsWithValue.click_on_offer_count(clickedCounter);
};

export const resetPredictionExperimentCounter = () => {
  flightsSessionStore.set(FLEXIBILITY_PREDICTION_EXPERIMENT_COUNTER_KEY, {});
};

export default utils;
